export class BoatService {
  static saveCurrentBoatId(id: string) {
    localStorage.setItem("currentSavingBoatId", id);
  }

  static get getCurrentBoatId(): string | null {
    return localStorage.getItem("currentSavingBoatId");
  }

  static clearSavedBoat(){
    localStorage.removeItem("createStoreDetails")
    localStorage.removeItem("onBoardingStorage")
    localStorage.removeItem("onBoardingDetailsStorage")
    localStorage.removeItem("createStoreAddress")
    localStorage.removeItem("currentSavingBoatId")
  }
}

export type createBoat = {
  brand: string;
  model: string;
  color: string;
  year: string;
  lastMaintenanceDate: Date;
  country: string;
  address: string;
  address2?: string;
  state: string;
  // postalCode: string;
  features: string[];
  userId: string;
};

